export default "__VITE_ASSET__DAdy7H8d__"